var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZoomOut(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.94 15.067a5.85 5.85 0 003.436-1.114v.005l2.662 2.7a1.136 1.136 0 001.625 0 1.18 1.18 0 000-1.65l-2.706-2.749a6.073 6.073 0 00.921-3.226A5.99 5.99 0 008.94 3 5.99 5.99 0 003 9.033a5.99 5.99 0 005.94 6.034zm2.17-9.29a3.88 3.88 0 00-2.17-.624v.002A3.85 3.85 0 005.12 9.033a3.879 3.879 0 105.99-3.256zm.092 2.39H6.797c-.164 0-.297.103-.297.268v1.13c0 .165.133.268.298.268h4.405c.164 0 .297-.103.297-.268v-1.13c0-.165-.133-.268-.298-.268z",
    fill: "#0D2976"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOut);
export default ForwardRef;